export default __webpack_public_path__ + "static/media/photo4.38d1f245.jpg";